/** Small shared pieces for the Phase 4 operations pages (queues with hasMore paging, user cell). */
import { Badge, Button } from '@hopex/ui';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

export function Pager({
  page,
  hasMore,
  onPage,
}: {
  page: number;
  hasMore: boolean;
  onPage: (p: number) => void;
}) {
  if (page === 1 && !hasMore) return null;
  return (
    <nav aria-label="صفحه‌بندی" className="mt-3 flex items-center justify-end gap-2 text-[13px]">
      <Button size="sm" variant="ghost" isDisabled={page <= 1} onPress={() => onPage(page - 1)}>
        قبلی
      </Button>
      <span className="text-fg-muted">صفحه‌ی {page.toLocaleString('fa-IR')}</span>
      <Button size="sm" variant="ghost" isDisabled={!hasMore} onPress={() => onPage(page + 1)}>
        بعدی
      </Button>
    </nav>
  );
}

export function UserCell({
  userId,
  name,
  publicId,
  tab,
}: {
  userId: string | null;
  name: string | null;
  publicId: string | null;
  tab?: string;
}) {
  if (!userId) return <span className="text-fg-muted">—</span>;
  return (
    <Link
      to="/users/$id"
      params={{ id: userId }}
      search={tab ? { tab } : {}}
      className="flex flex-col hover:underline"
    >
      <span className="font-semibold">{name ?? 'بدون نام'}</span>
      {publicId && (
        <bdi dir="ltr" className="font-mono text-[11px] text-fg-subtle">
          {publicId}
        </bdi>
      )}
    </Link>
  );
}

export function Tone({
  map,
  code,
}: {
  map: Record<string, { label: string; tone: 'positive' | 'negative' | 'accent' | 'neutral' }>;
  code: string;
}) {
  const m = map[code];
  return <Badge tone={m?.tone ?? 'neutral'}>{m?.label ?? 'وضعیت ثبت‌شده'}</Badge>;
}

export function Counter({
  label,
  value,
  tone,
}: {
  label: string;
  value: ReactNode;
  tone?: string;
}) {
  return (
    <div
      className={`rounded-md border px-3.5 py-2.5 ${tone === 'alert' ? 'border-negative/40 bg-negative-tint' : 'border-line bg-surface-1'}`}
    >
      <p className="m-0 text-[12px] text-fg-muted">{label}</p>
      <p className="m-0 mt-0.5 text-[17px] font-bold">{value}</p>
    </div>
  );
}

export const num = (v: number | undefined) => (
  <bdi className="hx-num">{(v ?? 0).toLocaleString('en-US')}</bdi>
);
